import React from 'react'
// import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { ShieldCheck } from '../../svg/shield_check'
import { ShieldWarning } from '../../svg/shield_warning'
import s from './index.module.css'

const Fondos = () => {
  return (
    <section>
      <div className='tw-mt-8 tw-mt-8@lg tw-mb-8 tw-mb-8@lg'>
        <h2 className='font-family-secondary c-gray--4 fw-7 tw-m-0 tw-f-20 tw-f-24@lg tw-mb-4 tw-mb-4@lg'>
          Uso de cookies
        </h2>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          Este sitio web utiliza cookies, que son pequeños archivos que se almacenan en las computadoras 
          y que nos permiten recordar características o preferencias de la navegación que tienes en 
          nuestra web. Gracias a esto podemos personalizar los ingresos a la web en futuras visitas, 
          hacer más segura la navegación y conocer tus preferencias para ofrecerte información de tu 
          interés. Este sitio web utiliza los siguientes tipos de cookies:
        </p>
        <div className={`flex@lg tw-mb-4 tw-mb-6@lg`}>
          <div className={`w-100 w-50@lg tw-py-2 tw-pr-2 tw-p-4@lg`}>
            <div
              className={`${s.itemBox2} brad-4 shadow bg-white tw-p-8 tw-pb-10@lg`}
            >
              <ShieldCheck fill='#00CCCC' className={'tw-mb-4'}/>
              <h3 className='font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-20@lg tw-mb-2 tw-mb-4@lg tw-mt-0'>
                Cookies necesarias
              </h3>
              <div className='font-family-primary c-gray--4 fw-0 tw-f-14 tw-f-14@lg'>
                <p>
                  Permiten que el sitio web se ejecute con normalidad y puedas navegar en él de manera segura. 
                  Estas cookies no pueden ser deshabilitadas, ya que son imprescindibles para la navegación.
                </p>
              </div>
            </div>
          </div>

          <div className={`w-100 w-50@lg tw-py-2 tw-pr-2 tw-p-4@lg`}>
            <div
              className={`${s.itemBox2} brad-4 shadow bg-white tw-p-8 tw-pb-10@lg`}
            >
              <ShieldWarning fill='#00CCCC' className={'tw-mb-4'}/>
              <h3 className='font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-20@lg tw-mb-2 tw-mb-4@lg tw-mt-0'>
                Cookies necesarias
              </h3>
              <div className='font-family-primary c-gray--4 fw-0 tw-f-14 tw-f-14@lg'>
                <p>
                  Nos permiten conocer un poco mejor tus intereses y mostrarte mensajes de productos 
                  que te pueden interesar según tu historial de navegación. Estas cookies solo son 
                  utilizadas en caso nos hayas dado tu consentimiento al ingresar al sitio web.
                </p>
              </div>
            </div>
          </div>
        </div>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          Puedes configurar tu navegador para aceptar o rechazar la instalación de cookies o 
          suprimirlos una vez que hayas finalizado la navegación en nuestro sitio web. Pacífico 
          no se responsabiliza de que la desactivación de las cookies pueda impedir el buen 
          funcionamiento de nuestra web.
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          En caso nos des tu autorización, cuando visites este sitio web almacenaremos o 
          recuperaremos información en el navegador a través de cookies no necesarias. La 
          información que captemos permitirá que el sitio funcione como esperas que lo haga 
          y se adecue de mejor manera a tus preferencias.
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          Bloquear o no dar tu consentimiento a algunos tipos de cookies puede afectar tu 
          experiencia en el sitio, así como los servicios que te podemos ofrecer. Sin embargo, 
          la aceptación o denegatoria del uso de cookies no necesarias no condiciona la 
          navegación en el sitio web ni la prestación de los servicios que nos solicites.
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          En cualquier momento podrás ejercer tu derecho de desactivación o eliminación de 
          las cookies. Estas acciones se realizan en la sección de Privacidad del navegador 
          que utilices.
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          En caso nos des tu autorización, al tratamiento de la información que captemos 
          le resultará aplicable nuestra Política de Privacidad.
        </p>
      </div>
    </section>
  )
}

export default Fondos
